/**
 * Mounts the Command Bar for every authenticated page and owns the
 * Ctrl/Cmd+K shortcut. Renders nothing when signed out.
 */
import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { subscribeCommandBar } from "@/lib/commandBarBus";
import { CommandBar } from "./CommandBar";

export function GlobalCommandBar() {
  const { status } = useAuth();
  const [open, setOpen] = useState(false);
  const authed = status === "authed";

  useEffect(() => {
    if (!authed) {
      setOpen(false);
      return;
    }
    const onKey = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
        event.preventDefault();
        setOpen((value) => !value);
      }
    };
    window.addEventListener("keydown", onKey);
    const unsubscribe = subscribeCommandBar(() => setOpen(true));
    return () => {
      window.removeEventListener("keydown", onKey);
      unsubscribe();
    };
  }, [authed]);

  if (!authed) return null;

  return <CommandBar open={open} onOpenChange={setOpen} />;
}
